module.exports = __webpack_public_path__ + "img/icons-list-6.d11f39a3.png";